import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { CopyUrlButton, CopyUrlButtonProps } from '..';
import { VisualAsync } from '../../test/visual/VisualAsync';
import {
  CopyUrlButtonDriver,
  copyUrlButtonDriverFactory,
} from './CopyUrlButton.driver';

const CopyUrlButtonVisual = (props: Partial<CopyUrlButtonProps>) => (
  <div style={{ backgroundColor: 'gray' }}>
    <CopyUrlButton
      {...props}
      url="wix.com"
      tooltipText="Copy link"
      successText="Link Copied"
    />
  </div>
);

visualize('CopyUrlButton', () => {
  story('render', () => {
    snap('light', <CopyUrlButtonVisual socialBarTheme="light" />);
    snap('dark', <CopyUrlButtonVisual socialBarTheme="dark" />);
  });

  const its = [
    { it: 'click', props: {} },
    { it: 'click on disabled', props: { disabled: true } },
  ];
  const focusTests = [
    {
      describe: 'focus / button',
      its,
      action: (driver: CopyUrlButtonDriver) => driver.click(),
    },
    {
      describe: 'focus / anchor',
      its: its.map((item) => ({ ...item, props: { ...item.props, as: 'a' } })),
      action: (driver: CopyUrlButtonDriver) => driver.focus(),
    },
  ];
  focusTests.forEach(({ describe, its, action }) =>
    story(describe, () => {
      its.forEach(({ it, props }) =>
        snap(it, (done) => (
          <VisualAsync
            checkered
            driverFactory={copyUrlButtonDriverFactory}
            onDone={done}
            action={action}
          >
            <CopyUrlButton
              {...props}
              url="wix.com"
              tooltipText="Copy link"
              successText="Link Copied"
            />
          </VisualAsync>
        )),
      );
    }),
  );
});
